import { HTTP } from './http-common'

let userTemp = {
  id: 'a1',
  name: 'Gustavo Krause',
  email: 'gustavo.krause@mirumagency.com',
}


export default {

  getUser() {
    return new Promise((resolve, reject) => {
      // HTTP.get(`/api/user`).then((response) => {
        // resolve(response.data.data);
        resolve(userTemp)
      // })
      // .catch((error) => {
        // reject(error)
      // });
    })
  },

  getIP() {
    return HTTP.get('https://ipapi.co/json').then((response) => {
      return response
    })
    .catch(_ => ({ data: { ip: '' } }))
  },

}



// WEBPACK FOOTER //
// ./src/api/user.js